import {TagProps} from 'antd';

import {LEADER_POSITION, MAX_TOP_POSITION} from './answers-feed-const';

export function getPositionTagColor(position: number): TagProps['color'] {
    if (position <= LEADER_POSITION) {
        return 'gold';
    }

    if (position <= MAX_TOP_POSITION) {
        return 'blue';
    }

    return 'default';
}
